import React from "react";
import TrendPanel from "./TrendPanel";
import ChannelPanel from "./ChannelPanel";
import { buildSeries, channelShares, collectionRows } from "./courtStatsMetrics";
import { fmtMoney, fmtPct0 } from "./statsFormat";

/**
 * Evolución y canales tab: the trend of one metric (occupancy, revenue or reservations) for this
 * period against the comparison period, with a table twin, next to the channel breakdown.
 *
 * @param {{current: object, comparison: object|null, compareMode: string, bucket: number}} props
 *   `bucket` groups days (1 = daily, 7 = weekly average) to keep long ranges readable.
 */
export default function EvolucionTab({ current, comparison, compareMode, bucket }) {
  const collections = collectionRows(current.totals).map((row) => ({
    key: row.key,
    label: row.label,
    value: fmtMoney(row.amount),
    muted: fmtPct0(row.share),
  }));

  return (
    <div className="stats-row-2">
      <TrendPanel
        current={current}
        comparison={comparison}
        compareMode={compareMode}
        bucket={bucket}
        buildSeries={buildSeries}
        countButton="Reservas"
      />
      <ChannelPanel
        channels={channelShares(current.channels)}
        subtitle="Por dónde entran las reservas y cómo se cobran."
        unit="reservas"
        emptyText="Sin reservas en el período."
        sections={[{ title: "Cobros del período", rows: collections }]}
      />
    </div>
  );
}
